import { Inbox } from '@packlink/packlink-sdk';
import { inboxToPath } from './utils/paths';

export const APP_ROUTE = {
    SETTINGS: {
        INDEX: '/settings',
        BILLING: '/settings/billing',
        BILLING_TRANSACTIONS: '/settings/billing/transactions',
        BILLING_INVOICES: '/settings/billing/invoices',
        BILLING_INVOICING: '/settings/billing/invoicing',
        BILLING_PAYMENT: '/settings/billing/payment',
        ADDRESSES: '/settings/addresses',
        ADDRESSES_SENDER: '/settings/addresses/sender',
        ADDRESSES_RECIPIENT: '/settings/addresses/recipient',
        API_KEY: '/settings/api-key',
        ARCHIVING: '/settings/archiving',
        INTEGRATIONS: '/settings/integrations',
        INTEGRATIONS_ALIAS: '/settings/integrations/:alias',
        OWN_CONTRACTS: '/settings/own-contracts',
        PARCELS: '/settings/parcels',
        PRIVACY: '/settings/privacy',
        SHIPPING_RULES: '/settings/shipping-rules',
        YOUR_ACCOUNT: '/settings/your-account',
        VOLUME_DISCOUNT: '/settings/volume-discounts',
        BRANDED_EMAILS: '/settings/branded-emails',
        BRANDED_EMAILS_EMAIL_TEMPLATES: '/settings/branded-emails/email-templates',
        BRANDED_EMAILS_BRAND_SETTINGS: '/settings/branded-emails/brand-settings',
    },
    INTEGRATIONS: {
        ACTIVATE_START_FLOW: '/integrations/:alias/activate/start-flow',
        AMAZON_ACTIVATE_START_FLOW: '/integrations/amazon/activate/start-flow',
        AMAZON_ACTIVATE_COMPLETE_FLOW: '/integrations/amazon/activate/complete-flow',
        EBAY_ACTIVATE_START_FLOW: '/integrations/ebay/activate/start-flow',
        EBAY_ACTIVATE_COMPLETE_FLOW: '/integrations/ebay/activate/complete-flow',
        ETSY_ACTIVATE_START_FLOW: '/integrations/etsy/activate/start-flow',
        ETSY_ACTIVATE_COMPLETE_FLOW: '/integrations/etsy/activate/complete-flow',
    },
    SUBSCRIPTIONS: {
        INDEX: '/subscriptions',
    },
    ANALYTICS: {
        INDEX: '/analytics',
    },
    BRANDED_EMAILS: {
        LABEL_CREATED: '/branded-emails/label-created',
        DEFAULT: '/branded-emails/default',
    },
    SHIPMENTS: {
        INDEX: '/shipments',
        BULK_SUMMARY: '/shipments/bulk/summary',
        INBOX: '/shipments/:inbox',
        INBOX_ALL: `/shipments/${inboxToPath(Inbox.ALL)}`,
        INBOX_READY_TO_PURCHASE: `/shipments/${inboxToPath(Inbox.READY_TO_PURCHASE)}`,
        DETAILS: '/shipments/:id/details',
    },
    CHECKOUT: {
        EDIT: '/shipments/:id/create',
        STEP: '/shipments/:id?/create/:step',
        STEP_INFO: '/shipments/:id?/create/info',
        STEP_SERVICE: '/shipments/:id?/create/service',
        STEP_ADDRESS: '/shipments/:id?/create/address',
        STEP_CUSTOMS: '/shipments/:id?/create/customs',
        STEP_PAYMENT: '/shipments/:id?/create/payment',
    },
    AUTH: {
        LOGIN: '/:partner/login',
        REGISTER: '/:partner/register',
        RECOVER_PASSWORD: '/:partner/recover-password',
        RECOVER_PASSWORD_CONFIRM: '/:partner/new-password',
    },
    SUPPORT_CENTER: {
        INDEX: '/support-center',
        TICKET_DETAILS: '/support-center/details/:id',
        NEW_TICKET: '/support-center/new-ticket',
    },
    ONBOARDING: {
        SELECT_PLAN: '/onboarding/select-plan',
        WELCOME: '/onboarding/welcome',
    },
    ERROR: {
        INDEX: '/error',
    },
} as const;
